<script lang="ts">

    import { storeLoader } from '../scripts/store';

</script>

<style lang="scss">

// scaling... any units
$width: 100px;

.loader {
  position: relative;
  margin: 40% auto;
  width: $width;
  &:before {
    content: '';
    display: block;
    padding-top: 100%;
  }
}

.circular {
  animation: rotate 2s linear infinite;
  height: 100%;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}

@keyframes color {
  100%,
  0% {
    stroke: $color_primary;
  }
  40% {
    stroke: $color_orange;
  }
  66% {
    stroke: $color_white;
  }
  80%,
  90% {
    stroke: $color_black;
  }
}

// demo-specific
body {
  background-color: $color_white;
}
.showbox {
    z-index: 100000;
    display: none;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: grey;
    opacity: 0.5;
    &--display {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
}

</style>

<div class="showbox" class:showbox--display={$storeLoader}>
    <div class="loader">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
      </svg>
    </div>
  </div>